import FileMessage from './FileMessage';

export default FileMessage;
